import React, { useState } from 'react';
import { NavigationProps } from '../types/navigation';
import { Button } from '../components/ui/Button';
import { MapPin, Lock, Info } from 'lucide-react';
import { useStore } from '../lib/store';
export function EventsPage({
  onNavigate
}: NavigationProps) {
  const {
    events,
    addReservation,
    reservations,
    user
  } = useStore();
  const [showPointsInfo, setShowPointsInfo] = useState(false);
  return <div className="min-h-screen bg-gray-50 pb-24" data-id="element-359">
      <div className="px-6 pt-12 pb-4 bg-white sticky top-0 z-10 shadow-sm flex justify-between items-center" data-id="element-360">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-361">Fishing Spots</h1>
        <button onClick={() => setShowPointsInfo(true)} className="text-blue-500 text-sm font-bold flex items-center bg-blue-50 px-3 py-1 rounded-full" data-id="element-362">
          <Info className="w-4 h-4 mr-1" data-id="element-363" />
          How to earn points
        </button>
      </div>

      <div className="p-4 space-y-4" data-id="element-364">
        {events.map(event => {
        const isReserved = reservations.some(r => r.eventId === event.id);
        const isLocked = (user?.points || 0) < event.requiredPoints;
        return <div key={event.id} className={`bg-white rounded-xl p-4 shadow-sm flex flex-col space-y-3 relative overflow-hidden ${isLocked ? 'opacity-75' : ''}`} data-id="element-365">
              {isLocked && <div className="absolute inset-0 bg-gray-100/50 backdrop-blur-[1px] z-10 flex items-center justify-center" data-id="element-366">
                  <div className="bg-white px-4 py-2 rounded-xl shadow-lg flex items-center space-x-2" data-id="element-367">
                    <Lock className="w-4 h-4 text-gray-400" data-id="element-368" />
                    <span className="text-sm font-bold text-gray-600" data-id="element-369">
                      Requires {event.requiredPoints} pts
                    </span>
                  </div>
                </div>}

              <div className="flex justify-between items-start" data-id="element-370">
                <div data-id="element-371">
                  <span className="text-xs font-bold text-blue-500 uppercase tracking-wide" data-id="element-372">
                    {event.theme}
                  </span>
                  <h3 className="font-bold text-gray-900 text-lg" data-id="element-373">
                    {event.title}
                  </h3>
                  <p className="text-sm text-gray-500" data-id="element-374">
                    {event.brand} • {event.date}
                  </p>
                </div>
                <div className="bg-gray-100 px-2 py-1 rounded text-xs font-bold text-gray-600" data-id="element-375">
                  {event.time}
                </div>
              </div>

              <div className="flex items-center text-sm text-gray-600 bg-gray-50 p-2 rounded-lg" data-id="element-376">
                <MapPin className="w-4 h-4 mr-2 text-gray-400" data-id="element-377" />
                <span className="truncate" data-id="element-378">{event.address}</span>
              </div>

              <div className="flex items-center justify-between pt-2" data-id="element-379">
                <span className="text-sm font-medium text-gray-500" data-id="element-380">
                  {event.boxesLeft} / {event.totalBoxes} spots
                </span>
                <Button size="sm" onClick={() => !isReserved && addReservation(event.id)} disabled={isReserved || isLocked} className={isReserved ? 'bg-green-100 text-green-700 hover:bg-green-200' : 'px-6'} data-id="element-381">
                  {isReserved ? 'Reserved' : 'Paxa'}
                </Button>
              </div>
            </div>;
      })}
      </div>

      {/* Points Info Modal */}
      {showPointsInfo && <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4 animate-in fade-in" data-id="element-382">
          <div className="bg-white rounded-2xl p-6 w-full max-w-sm relative" data-id="element-383">
            <button onClick={() => setShowPointsInfo(false)} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600" data-id="element-384">
              ✕
            </button>

            <h2 className="text-xl font-bold mb-4" data-id="element-385">How to earn points</h2>
            <div className="space-y-4" data-id="element-386">
              <div className="flex items-center justify-between p-3 bg-gray-50 rounded-xl" data-id="element-387">
                <span data-id="element-388">Invite a friend</span>
                <span className="font-bold text-blue-600" data-id="element-389">+40 pts</span>
              </div>
              <div className="flex items-center justify-between p-3 bg-gray-50 rounded-xl" data-id="element-390">
                <span data-id="element-391">Leave a review</span>
                <span className="font-bold text-blue-600" data-id="element-392">+30 pts</span>
              </div>
              <div className="flex items-center justify-between p-3 bg-gray-50 rounded-xl" data-id="element-393">
                <span data-id="element-394">Redeem a box</span>
                <span className="font-bold text-blue-600" data-id="element-395">+20 pts</span>
              </div>
              <div className="flex items-center justify-between p-3 bg-gray-50 rounded-xl" data-id="element-396">
                <span data-id="element-397">Reserve a spot</span>
                <span className="font-bold text-blue-600" data-id="element-398">+10 pts</span>
              </div>
            </div>
            <Button onClick={() => setShowPointsInfo(false)} className="w-full mt-6" data-id="element-399">
              Got it
            </Button>
          </div>
        </div>}
    </div>;
}